import { useState, useMemo } from "react";

import Text from "./Text";
import { Row, Col } from "./Flexbox";
import { Button } from "@mui/material";
import TextContainer from "./TextContainer";

const CAPTURA_KEY = 'CAPTURA'; // Reserved item with the captura limits, not a machine

const ModifyResources = ({resources, theme, onClose, onSave, isLoading, percentages}) => {

    const initialVals = useMemo(() => {
        const map = {};
        if (Array.isArray(percentages)) {
            percentages.forEach(item => {
                if (item.machine === CAPTURA_KEY || item.machine.startsWith('SEMANA#')) return;
                map[item.machine] = item.efficiency;
            });
        }
        return map;
    }, [percentages]);

    const initialCaptura = useMemo(() => {
        const item = Array.isArray(percentages) ? percentages.find(p => p.machine === CAPTURA_KEY) : null;
        return {min: item?.capturaMin ?? "", max: item?.capturaMax ?? ""};
    }, [percentages]);

    const [values, setValues] = useState(initialVals || {});
    const [captura, setCaptura] = useState(initialCaptura);

    // Machines from the bonus data first, then saved machines that didn't show up in it
    const rows = useMemo(() => {
        const saved = Object.keys(initialVals).filter(machine => !resources.includes(machine));
        return [...resources, ...saved];
    }, [resources, initialVals]);

    const handleInputChange = (machine, val) => {
        setValues(prev => ({...prev, [machine]: val}))
    }

    const handleCapturaChange = (field, val) => {
        setCaptura(prev => ({...prev, [field]: val}))
    }

    const handleSave = () => {
        const hasCaptura = String(captura.min).trim() !== "" || String(captura.max).trim() !== "";
        onSave(hasCaptura ? {resources: values, captura} : {resources: values});
    }

    return (
        <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0, 0, 0, 0.5)', alignItems: 'center', display: 'flex', justifyContent: 'center', zIndex: 1000, boxSizing: 'border-box'}}>
            <style>
                {`
                    ::-webkit-scrollbar {display: none;}
                `}
            </style>
            <Col style={{maxWidth: '600px', height: '620px', padding: '32px', gap: 32, boxSizing: 'border-box', backgroundColor: theme.White, borderRadius: 4}}>
                <Text color={theme.ONED} weight={800} size={21} style={{textAlign: 'start', width: '100%'}}>Modificar recursos</Text>
                <Row style={{width: '100%', alignItems: 'center', gap: 16, flex: 'none'}}>
                    <Text color={theme.ONED} style={{flex: 1, textAlign: 'start'}}>Captura</Text>
                    <TextContainer style={{width: '120px', height: 36, textAlign: 'start'}} theme={theme} placeHolder='Mínimo %' value={captura.min} onChange={(val) => handleCapturaChange('min', val)}/>
                    <TextContainer style={{width: '120px', height: 36, textAlign: 'start'}} theme={theme} placeHolder='Máximo %' value={captura.max} onChange={(val) => handleCapturaChange('max', val)}/>
                </Row>
                <div style={{width: '100%', minHeight: '414px', maxHeight: '414px', overflowY: 'auto'}}>
                    <table style={{width: '100%', borderCollapse: 'collapse', textAlign: 'left'}}>
                        <thead style={{position: 'sticky', top: 0, backgroundColor: theme.White, zIndex: 1}}>
                            <tr>
                                <th style={{paddingBottom: '16px'}}><Text color={theme.ONED}>Recurso</Text></th>
                                <th style={{paddingBottom: '16px', width: '160px'}}><Text color={theme.ONED}>Eficiencia mínima</Text></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length > 0 && rows.map(machine => (
                                <tr key={machine}>
                                    <td style={{padding: '6px'}}><Text color={theme.ONED}>{machine}</Text></td>
                                    <td style={{padding: '6px'}}>
                                        <TextContainer style={{width: '150px', height: 36, textAlign: 'start'}} theme={theme} placeHolder='0%' value={values[machine] || ""} onChange={(val) => handleInputChange(machine, val)}/>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Row style={{width: '100%', alignItems: 'center', justifyContent: 'end', gap: 16, marginTop: '16px', flex: 'none'}}>
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Lao} size={15} onClick={onClose}>Cancelar</Text>
                    <Button disabled={isLoading} onClick={handleSave} sx={{height: 20, backgroundColor: 'transparent', color: theme.Magenta, fontSize: 15, textTransform: 'none'}}>{isLoading ? "Guardando..." : "Guardar"}</Button> 
                </Row>
            </Col>
        </div>
    )
}

export default ModifyResources;